<template>
  <div class="pageMain">
     <full-loading :fullLoadingShow="fullLoadingShow"></full-loading>
    <div v-if="success">
      <div class="nobutton">
        无牌车
      </div>
      <div class="parkName">
        {{ parkName }}
      </div>
      <div class="status">
        <img src="@assets/images/success.png" alt="">
      </div>
      <div class="tip">
        扫码成功，欢迎入场
      </div>
    </div>
    <div v-else>
        <div class="status" style="padding-top: 50px">
          <img src="@assets/images/error_1.png" alt="">
        </div>
      <div class="tip">
        {{ msg }}
      </div>
    </div>
    <div class="back" @click="goBack">
      返回
    </div>
    <div class="tips">
      <h2>无牌车自助停车指南:</h2>
      <p>1.入场扫码成功后，闸道自动开启，车辆入场。</p>
      <p>2.出场前缴费，出场时扫码开闸。也可出场时扫码缴费开闸。</p>
    </div>
  </div>
</template>

<script>
export default {
   name: "noNumCar",
   data(){
     return{
       fullLoadingShow: true,
       parkName:"",
       parkId:'',
       inCtrlNo:'',
       success:1,
       msg:''
     }
   },
  created() {
      this.parkId = this.$route.query.parkId || '';
      this.inCtrlNo = this.$route.query.inCtrlNo || '';
      if(this.parkId && this.inCtrlNo ){
        this.noplatein();
      }else{
        this.fullLoadingShow = false;
        this.success = 0;
        this.msg = '链接错误';
      }
    },
   methods:{
     noplatein() {
       let data = {
         inCtrlNo:this.inCtrlNo,
         parkId:this.parkId,
       };
       console.log('对应数据',data);
       this.$apis.noplatein(data).then((res) => {
         console.log(res.msg);
         this.fullLoadingShow = false;
         if (res.code === 200) {
              this.parkName = res.data.park_name || '';
         }else{
              this.success = 0;
              this.msg = res.msg;
         }
       });
     },
     goBack(){
       this.$router.push('/index')
     },
     noNumCarPay(){
       this.$router.push('/noNumCarPay')
     }
   }
}
</script>

<style scoped>
  .nobutton{
    padding: 0.2rem 0;
    background-color: #ff8500;
    color: #fff;
    border-radius: 0.06rem;
    text-align: center;
    font-size: 0.34rem;
    width: 4.6rem;
    margin-left: auto;
    margin-right: auto;
    margin-top: .4rem;
    letter-spacing: .1rem;
  }
  .parkName{
    text-align: center;
    font-size: .28rem;
    margin: .55rem auto;
  }
  .status{
    margin: .1rem auto .8rem auto;
    text-align: center;
  }
  .status img{
    width: 1.1rem;
  }
  .tip{
    text-align: center;
    font-size: .32rem;
    margin: .52rem auto;
  }
  .back{
    width: 5rem;
    height: .8rem;
    border-radius: .8rem;
    text-align: center;
    line-height: .8rem;
    color: #ff8500;
    border: 1px solid #ff8500;
    margin-left: auto;
    margin-right: auto;
  }
  .tips{
    font-size: .25rem;
    color: #ff8500;
    position: fixed;
    bottom: .55rem;
    left: .45rem;
    right: .45rem;
  }
  .tips h2{
    font-weight: normal;
    font-size: .25rem;
  }
</style>
